import { Button, Typography } from "@mui/material";
import StatusLabel from "../../../StatusLabel/StatusLabel";
import { receiveStatus } from "../../../../util/receiveStatus";
import { useStyles } from "../../Search.styles";

type StatusProps = {
	status?: string;
	isArrivalsFeatureEnabled: boolean;
	handleCheckinClick: (event: React.MouseEvent<HTMLElement>) => void;
};
export const SearchResultLinkStatus = ({ status, isArrivalsFeatureEnabled, handleCheckinClick }: StatusProps) => {
	const classes = useStyles();
	return status !== receiveStatus.open || !isArrivalsFeatureEnabled ? (
		<>
			<Typography variant="caption" color="textSecondary" component="div" className={classes.titleText}>
				Status
			</Typography>
			{status && <StatusLabel status={status} size="extraSmall" />}
		</>
	) : (
		<Button variant="contained" color="primary" onClick={handleCheckinClick} className={classes.checkIn}>
			Check in
		</Button>
	);
};
